import axiosAgent from './axiosAgent';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ApiConfig from '../config/ApiConfig';
import { store } from '../store';
// import { CreateCourseId } from '../containers/Pages/CreateCourse/actions';
import {
    setCurrentScreenLoading,
    setCurrentScreenName,
    setCurrentScreenState,
    setShowAddButtons,
} from '../containers/Pages/CreateCourse/Slices/currentScreen';
import { getCurrentCourse } from '../containers/Pages/CreateCourse/Slices/currentCourse';
import jwtDecode from 'jwt-decode';

export const uploadThumbnail = async (thumbnail, dispatch, courseId) => {
    console.log('Course ID boom', courseId);
    console.log('Thumbnail', thumbnail);

    const data = new FormData();
    data.append('thumbnail', thumbnail);
    console.log('new formdata', data);

    const response = await axiosAgent.put(
        `${ApiConfig.course.uploadCourseContent}/${courseId}`,
        data,
    );
    console.log('RESPONSE=', response);
    if (response.data.success === true) {
        console.log('toast1');
        toast.success(response.data.message);
    } else {
        alert('cant create course');
    }
};

export const createCourse = async (
    formData,
    setCourseId,
    toggleUpdate,
    navigate,
    thumbnail,
) => {
    if (thumbnail === '' || thumbnail === null) {
        toast.error('cant create course');
    } else {
        const response = await axiosAgent.post(
            ApiConfig.course.createCourse,
            formData,
        );
        console.log('course Created', response.data);
        await uploadThumbnail(
            thumbnail,
            store.dispatch,
            response.data.data._id,
        );
        localStorage.setItem('courseId', response.data.data._id);
        store.dispatch(getCurrentCourse(response.data.data));
        store.dispatch(setShowAddButtons(false));
        store.dispatch(setCurrentScreenName('manual'));
        store.dispatch(setCurrentScreenState(false));
        // setOverview(false);
        const id = response.data.data._id;
        //
        navigate(`/dashboard/courses/edit-course/${id}`);
        return response.data.data._id;
    }
};

export const getAllCourses = async (page, limit) => {
    const url =
        page && limit
            ? `${ApiConfig.course.getAllCourse}?page=${page}&limit=${limit}`
            : ApiConfig.course.getAllCourse;
    const response = await axiosAgent.get(url);
    console.log('courses fetched', response);
    if (page && limit) {
        return {
            courses: response.data.data.courses,
            total: response.data.data.total,
        };
    }
    return response.data.data;
};
export const instructorRecentCourses = async () => {
    const currentDate = new Date();
    const month = currentDate.getMonth();
    const year = currentDate.getFullYear();
    const date = currentDate.getDate();
    console.log('Current Date', currentDate.getMonth());
    const response = await axiosAgent.get(
        `${ApiConfig.course.instructorRecentCourses}`,
    );

    const recentCourses = response.data.data;
    return recentCourses;
};

export const editCourse = async (formData, courseId) => {
    const response = await axiosAgent.put(
        `${ApiConfig.course.editCourse}/${courseId}`,
        formData,
    );

    console.log('course Edited', response.data);
    // store.dispatch(CreateCourseId(response.data.data._id));
    return response.data.data._id;
};

export const getSubCategoriesById = async (majorId) => {
    const response = await axiosAgent.get(
        `${ApiConfig.subCategory.getSubCategoriesById}/${majorId}`,
    );
    console.log('Subcats Fetched', response.data);
    return response.data.data;
};

export const getIndividualCourse = async (courseId) => {
    const response = await axiosAgent.get(
        `${ApiConfig.course.getCourse}/${courseId}`,
    );
    console.log('response of Get individual course api', response.data.data);
    return response.data.data;
};

export const editQuestion = async (formData, questionId, dispatch) => {
    dispatch(setCurrentScreenLoading(true));
    await axiosAgent.put(
        `${ApiConfig.section.editQuestion}/${questionId}`,
        formData,
    );
    dispatch(setCurrentScreenLoading(false));
};

export const createQuestion = async (formData, sectionId) => {
    store.dispatch(setCurrentScreenLoading(true));
    console.log('again', formData, sectionId);
    const response = await axiosAgent.post(
        `${ApiConfig.section.createQuestion}/${sectionId}`,
        formData,
    );
    store.dispatch(setCurrentScreenLoading(false));
    return response;
};
export const myCourses = async (setData, page, setCount, setIsloading) => {
    const token = localStorage.getItem('token');
    // console.log('inside my course of student');
    let user = token && jwtDecode(token);

    const response = await axiosAgent.get(
        `${ApiConfig.course.studentCoursePagination}?page=${page}`,
    );
    console.log('my couse api data of student with format', response.data);
    // let arr = response.data.studentEnrollCourses;

    setData(response.data.data);
    setCount(response.data.total_pages);
    setIsloading(false);
};

export const myCoursesofInstructor = async (
    setData,
    page,
    setCount,
    setIsloading,
) => {
    const token = localStorage.getItem('token');
    let user = token && jwtDecode(token);
    console.log('User in local storage', user);
    const response = await axiosAgent.get(
        `${ApiConfig.course.allCoursesofInstructor}/${user._id}?page=${page}`,
    );
    setIsloading(false);
    console.log('jkjjjjjjjkjkjj');
    console.log('my couse api data of instructor', response.data);
    let arr = response.data.data;
    let filteredArray = arr.filter((item) => item.isDeleted === false);
    console.log('FILTERED ARRAY,', filteredArray);
    setCount(response.data.total_pages);
    setData(filteredArray);
};

export const recoverCourse = async (courseId, navigate, toast) => {
    console.log('COURSEid', courseId);

    let response = await axiosAgent.get(
        `${ApiConfig.course.recoverCourse}/${courseId}`,
    );

    console.log('REsponse', response);
    if (response.data.success) {
        toast.success('course recovered successfully');
        setTimeout(() => {
            navigate('/dashboard/courses');
        }, 5000);
    }
};
export const getIndividualQuestion = async (questionId) => {
    const response = axiosAgent.get(
        `${ApiConfig.section.getIndividualQuestion}/${questionId}`,
    );
    console.log('Individual question response', response);
    return response;
};

export const deleteCourse = async (courseId, navigate, toast) => {
    console.log('inside delete course');

    const response = await axiosAgent.delete(
        `${ApiConfig.course.deleteCourse}/${courseId}`,
    );
    console.log('response of delete course api', response.data.success);
    if (response.data.success) {
        toast.success('course deleted successfully');
        setTimeout(() => {
            navigate('/dashboard/courses');
        }, 5000);
    }
};

export const addToRecentlyDeleted = async (courseId, navigate, toast) => {
    let response = await axiosAgent.post(
        `${ApiConfig.course.addToRecentlyDeleted}/${courseId}`,
        {},
    );

    console.log('response of recently deleted', response);
    if (response.data.success) {
        toast.success('course deleted successfully');
        setTimeout(() => {
            navigate('/dashboard/courses');
        }, 5000);
    }
};

export const getIndividalSection = async (sectionId) => {
    const response = await axiosAgent.get(
        `${ApiConfig.section.getIndividalSection}/${sectionId}`,
    );
    console.log('response of individualSection', response.data.data);
    return response.data.data.title;
};

export const getReviews = async (courseId) => {
    const response = await axiosAgent.get(
        `${ApiConfig.reviews.getReview}/${courseId}`,
    );
    return response;
};

export const addToRecent = async (courseId) => {
    console.log('courseId for add to recent', courseId);
    const response = await axiosAgent.get(
        `${ApiConfig.course.addToRecent}/${courseId}`,
    );
    console.log('response of add to recent', response);
};

export const getCourseProgress = async (
    courseId,
    studentId,
    setCount,
    setTotalEnrolled,
    setCourseInProgress,
    setCompletionRate,
) => {
    console.log('studentId and courseId', courseId, studentId);

    let response = await axiosAgent.get(
        `${ApiConfig.course.getCourseProgress}/${courseId}/${studentId}`,
    );

    console.log('Response of course Progresss', response.data);
    if (response.data.success) {
        console.log('in success');
        setCount(response.data.count);
        setTotalEnrolled(response.data.totalEnrolledCourse);
        setCourseInProgress(response.data.coursesInProgress);
        setCompletionRate(response.data.averageCourseCompletionRate);
    }
};

export const totalAssignmentsOfParticularCourseOfInstructor = async (
    authorId,
    courseId,
    setTotalStudentsEnrolled,
    setTotalAssignments,
    setStudentsEnrolledInThisCourse,
    setTotalWatchTime,
) => {
    console.log('authorId', authorId);
    const validCourseId =
        courseId && courseId !== 'undefined' ? courseId : 'all';

    let response = await axiosAgent.get(
        `${ApiConfig.course.totalAssignmentsOfParticularCourseOfInstructor}/${validCourseId}`,
    );

    console.log(
        'Response of total Assignments in course of inst',
        response.data,
    );
    if (response.data.success) {
        console.log('in success');
        setTotalStudentsEnrolled(response.data.data || 0);
        setTotalAssignments(response.data.totalAssignments || 0);
        if (setTotalWatchTime && response.data.totalWatchTime) {
            setTotalWatchTime(response.data.totalWatchTime);
        }
        setStudentsEnrolledInThisCourse(
            response.data.studentsEnrolledInThisCourse || [],
        );
    }
};

export const getScoreOfCourseofParticularStudent = async (
    courseId,
    studentId,
) => {
    let response = await axiosAgent.get(
        `${ApiConfig.course.getScoreOfCourseofParticularStudent}/${courseId}/${studentId}`,
    );

    console.log('Response of score of student', response.data);
    if (response.data.success) {
        console.log('in success');
        return response.data.data;
    }
};

export const createReviews = async (data, courseId) => {
    const response = await axiosAgent.post(
        `${ApiConfig.reviews.createReview}/${courseId}`,
        data,
    );
    return response;
};

export const editReview = async (data, reviewId) => {
    const response = await axiosAgent.put(
        `${ApiConfig.reviews.editReviews}/${reviewId}`,
        {
            review: data,
        },
    );
    return response;
};

export const getAnswer = async (answer, questionId, courseId) => {
    const response = await axiosAgent.post(
        `${ApiConfig.section.getAnswer}/${questionId}/${courseId}`,
        {
            ans: answer,
        },
    );
    console.log('response of getAnswer', response);
    return response;
};
export const updateCourseProgress = async (courseId, lectureId, authorId) => {
    console.log('courseid', courseId, lectureId, authorId);

    let response = await axiosAgent.put(
        `${ApiConfig.course.updateCourse}/${courseId}/${lectureId}/${authorId}`,
        {},
    );

    console.log('response of update progress', response);
};

export const createCircular = async (data, toast) => {
    // console.log('about to create circular', file);
    const formData = new FormData();
    formData.append('agenda', data.agenda);
    formData.append('description', data.description);
    formData.append('role', data.role);
    // formData.append('allResources', file);

    try {
        const response = await axiosAgent.post(
            `${ApiConfig.circular.createCircular}`,
            data,
        );
        toast.success('Circular created successfully');
        return response;
    } catch (err) {
        console.log('err', err);
        toast.error("Can't create circular");
    }
};

export const uploadCircularPdf = async (allResources, id) => {
    const formData = new FormData();
    console.log('resource', allResources);
    formData.append('allResources', allResources[0]);
    console.log('file in func api', allResources);

    try {
        const response = await axiosAgent.post(
            `${ApiConfig.circular.uploadCircularPdf}/${id}`,
            formData,
        );
        console.log('res of upload circular resource', response);
        return response;
    } catch (err) {
        console.log('err', err);
    }
};

export const getAllCircular = async () => {
    try {
        const response = await axiosAgent.get(
            `${ApiConfig.circular.getCirculars}`,
        );
        return response;
    } catch (err) {
        console.log('err', err);
    }
};

export const createPolls = async (data) => {
    console.log('data in createpoll', data);
    try {
        const response = await axiosAgent.post(`${ApiConfig.poll.createPoll}`, {
            question: data.question,
            options: data.options,
        });
        toast.success('Poll created successfully');
        return response;
    } catch (err) {
        console.log('error', err);
        toast.success("Can't create poll");
    }
};

export const createSurveys = async (data) => {
    console.log('data in createsurvey', data);
    try {
        const response = await axiosAgent.post(
            `${ApiConfig.survey.createSurvey}`,
            {
                title: data.title,
                questions: data.questions,
            },
        );
        toast.success('Survey created successfully');
        console.log('resp of create survey', response);
        return response;
    } catch (err) {
        console.log('error', err);
        toast.success("Can't create survey");
    }
};

export const getPoll = async () => {
    try {
        const response = await axiosAgent.get(`${ApiConfig.poll.getPolls}`);
        return response.data.data;
    } catch (err) {
        console.log('err', err);
    }
};

export const getSurvey = async () => {
    try {
        const response = await axiosAgent.get(`${ApiConfig.survey.getSurvey}`);
        return response.data.data;
    } catch (err) {
        console.log('err', err);
    }
};

export const getVotesOfSurvey = async (id) => {
    try {
        const response = await axiosAgent.get(
            `${ApiConfig.survey.getVotesOfSurvey}/${id}`,
        );
        return response.data;
    } catch (err) {
        console.log('err', err);
    }
};

export const getVotesOfPoll = async (id) => {
    try {
        const response = await axiosAgent.get(
            `${ApiConfig.poll.getVotesOfPoll}/${id}`,
        );
        return response.data;
    } catch (err) {
        console.log('err', err);
    }
};

export const createSubCategory = async (formData, majorId, setOpen) => {
    const response = await axiosAgent.post(
        `${ApiConfig.subCategory.createCategory}/${majorId}`,
        formData,
    );

    console.log('Sub category Created', response.data);
    setOpen(false);
    return response.data.data;
};

export const getAllCategories = async () => {
    const response = await axiosAgent.get(ApiConfig.category.getAllCategories);
    console.log('response', response.data.data);
    return response.data.data;
};

export const getCourseByMajorCategory = async (majorCategory) => {
    console.log('major cat in front end', majorCategory);
    const response = await axiosAgent.post(
        ApiConfig.course.getCourseByMajorCategory,
        { majorCategory },
    );
    console.log('getCourseByMajorCategory response', response.data.data);
    return response.data.data;
};

export const getCourseBySubCategory = async () => {
    const response = await axiosAgent.get(
        ApiConfig.course.getCourseBySubCategory,
    );
    console.log('getCourseBySubCategory response', response);
    return response;
};
